export default "__VITE_ASSET__Dtnj_zx8__"